module.exports = __webpack_public_path__ + "static/media/chart-area-solid.544ad56f.svg";